<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Job \ <span class="ActiveURL">VtexJob Dashboard</span>  </span>
        
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
  <div class="row">
    <d-card class="card-small col-lg-12">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row> 
            <d-col>        
              <d-form id="pricing">
                <d-form-row>
                 
               
         <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <span><d-button type="button" id="Reload" title="Please Select the panel" class=""  @click="GetVtexJobList" style="float:right; margin-bottom:5px" ><i class="material-icons">view_module</i> Reload</d-button></span>
                <div class="grid-row" layout="row top-stretch">
                <ag-grid-vue style="width: 80%; height: 500px;"
                    class="ag-theme-alpine"
                    :columnDefs="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.columns"
                    :rowData="BrandMasterUpload.Masters.CategoryMaster"
                    id="myGrid"
                    :debug="true"
                    :pagination="true"
                    :defaultColDef="BrandMasterUpload.GridInfo.CategoryMasterDetailsInfoGrid.defaultColDef"
                    rowSelection="multiple">
                </ag-grid-vue>
                </div>
              </div>
            </div>
          </div>

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>

 
  </div>




    <div v-if="BrandMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from '@ag-grid-community/all-modules';
export default {
  name: 'BrandMasterUpload',
   data() {
    return {
      BrandMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            BrandMaster:null,
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            RejectedList:[],
            AvailablityTemplate:[],
            BrandMasterList:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        GridInfo: {
       
          CategoryMasterDetailsInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null,
            },
                defaultColDef: {
        editable: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true
    },
            AdditionalInfo: {
            gridOptions: null,
            gridApi: null,
            columnApi: null,
            autoGroupColumnDef: null,
            defaultColDef: null,
            rowSelection: null,
            rowGroupPanelShow: null,
            pivotPanelShow: null,
            modules: AllCommunityModules,
            },
            columns: [
                  {headerName: 'JobID', field: 'JobID'},
                // {headerName: 'Total', field: 'Total'},
                {headerName: 'TotalCount', field: 'TotalCount'},
                    {headerName: 'Updated', field: 'TotalRecordsUpdate'},
                {headerName: 'Rejected', field: 'Rejected'},
                {headerName: 'Status', field: 'Status'},
                {headerName: 'CreatedAt', field: 'CreatedAt'},
                {headerName: 'CompletedOn', field: 'CompletedOn'}
            ],
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },

        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          BrandMaster:[],
          CategoryMaster:[],

          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.BrandMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.BrandMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
    //    this.GetBrandMasterDetails();
       this.GetVtexJobList();
        //  fetch('https://www.ag-grid.com/example-assets/small-row-data.json')
        //         .then(result => result.json())
        //         .then(rowData => this.BrandMasterUpload.Masters.CategoryMaster = rowData);
  },
  
       beforeMount() {
          
          
        },
  methods: {
 
 
      GetBrandMasterDetails(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "ListBrandMaster";
      this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
      this.BrandMasterUpload.DataModel.UIData.RejectedList=[];
      var dataString = JSON.stringify(vm.BrandMasterUpload.DataModel.Data);
       vm.BrandMasterUpload.PageLoad = true;
       vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.Masters.BrandMaster = response.data.Result

          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
    
      vm.BrandMasterUpload.DataModel.UIData.UploadStatus = true;
      },

      DownloadBrand()
      {
        
      },

      DownloadCategory()
      {
        
      },

      

      GetVtexJobList(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "GetVtexJobList";
      this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
      this.BrandMasterUpload.DataModel.UIData.RejectedList=[];
      var dataString = JSON.stringify(vm.BrandMasterUpload.DataModel.Data);
       vm.BrandMasterUpload.PageLoad = true;
       vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/VtexJobService.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.Masters.CategoryMaster = response.data.Result

          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
    
      vm.BrandMasterUpload.DataModel.UIData.UploadStatus = true;
      },

 
  }
}
</script>